<template>
  <v-card class="add-hkiarace-banner">
    <v-card-title>{{ $t('admin_banner.add_title') }}</v-card-title>
    <v-card-text>
      <v-container fluid>
        <v-form ref="form">
          <v-text-field outlined
                        :label="$t('admin_banner.name')"
                        v-model="banner.name"
                        clearable
                        :rules="requiredRules"></v-text-field>
          <v-checkbox v-model="banner.require_login"
                      :label="$t('admin_banner.require_login')"></v-checkbox>
          <v-text-field outlined
                        :label="$t('admin_banner.path')"
                        v-model="banner.path"
                        clearable
                        :rules="requiredRules"></v-text-field>
          <v-input :rules="requiredRules"
                   hide-details="auto"
                   v-model="banner.from_time">
            <v-container fluid class="flex-column">
              <legend class="v-label theme--light">{{ $t('admin_banner.from_time') }}</legend>
              <DateTimePickerInput v-model="banner.from_time"
                                   hide-details></DateTimePickerInput>
            </v-container>
          </v-input>
          <v-input :rules="requiredRules"
                   hide-details="auto"
                   v-model="banner.to_time">
            <v-container fluid class="flex-column">
              <legend class="v-label theme--light">{{ $t('admin_banner.to_time') }}</legend>
              <DateTimePickerInput v-model="banner.to_time"
                                   hide-details></DateTimePickerInput>
            </v-container>
          </v-input>
          <v-row>
            <v-col>
              <v-input hide-details="auto"
                       v-model="bannerEn"
                       :rules="requiredRules">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_banner.banner_en') }}</legend>
                  <PhotoPreviewInput v-model="bannerEn"
                                     div-class="promotion-icon-input"
                                     file-name="promotion-icon"></PhotoPreviewInput>
                  <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG; RECOMMENDED SIZE: <b>335(W) X 335(H)</b></small>
                </v-container>
              </v-input>
            </v-col>
            <v-col>
              <v-input hide-details="auto"
                       v-model="bannerZh"
                       :rules="requiredRules">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_banner.banner_zh') }}</legend>
                  <PhotoPreviewInput v-model="bannerZh"
                                     div-class="promotion-icon-input"
                                     file-name="promotion-icon"></PhotoPreviewInput>
                  <small class="form-text text-muted">ACCEPTED FILE FORMAT: PNG, JPEG, JPG; RECOMMENDED SIZE: <b>335(W) X 335(H)</b></small>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_banner.link_en')"
                            v-model="banner.link_en"
                            clearable></v-text-field>
            </v-col>
            <v-col>
              <v-text-field outlined
                            :label="$t('admin_banner.link_zh')"
                            v-model="banner.link_zh"
                            clearable></v-text-field>
            </v-col>
          </v-row>
          <v-checkbox v-model="banner.with_content"
                      :label="$t('admin_banner.with_content')"></v-checkbox>
          <v-row v-if="banner.with_content">
            <v-col cols="12">
              <v-input hide-details
                       v-model="banner.content_en">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_banner.content_en') }}</legend>
                  <TinyMceEditor v-model="banner.content_en"></TinyMceEditor>
                </v-container>
              </v-input>
            </v-col>
            <v-col cols="12">
              <v-input hide-details
                       v-model="banner.content_zh">
                <v-container fluid class="flex-column">
                  <legend class="v-label theme--light">{{ $t('admin_banner.content_zh') }}</legend>
                  <TinyMceEditor v-model="banner.content_zh"></TinyMceEditor>
                </v-container>
              </v-input>
            </v-col>
          </v-row>
        </v-form>
      </v-container>
    </v-card-text>
    <v-card-actions class="text-right">
      <v-btn depressed
             large
             @click="$emit('submit', undefined)">
        {{ $t('cancel') }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn depressed
             large
             color="primary"
             @click="$refs.form.validate() && save()">
        {{ $t('save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import {ref} from "@vue/composition-api";
import DateTimePickerInput from "@/components/DateTimePickerInput";
import PhotoPreviewInput from "@/components/PhotoPreviewInput";
import TinyMceEditor from "@/components/TinyMceEditor";

export default {
  name: 'AddHkiaraceBannerModal',
  components: {TinyMceEditor, PhotoPreviewInput, DateTimePickerInput},
  setup(props, {root, emit}) {
    const requiredRules = ref([
      value => !!value || root.$t('register.required_fields'),
    ]);
    const getURL = function (f) {
      if (f instanceof File) {
        return URL.createObjectURL(f);
      } else {
        return 'api/static/' + f;
      }
    };

    const banner = ref({});
    const bannerEn = ref(null);
    const bannerZh = ref(null);

    const save = async function () {
      root.$callAPI('hkiarace/admin/banner/create/', {
        ...banner.value,

        banner_en: await root.$convertFileToBase64(bannerEn.value),
        banner_zh: await root.$convertFileToBase64(bannerZh.value),
      }, ()=> {
        emit('submit', true);
      });
    };

    return {
      requiredRules,
      getURL,
      banner,
      bannerEn,
      bannerZh,
      save,
    }
  },
}
</script>

<style lang="less">
.add-hkiarace-banner {
  display: flex !important;
  flex-direction: column !important;
  height: 100%;
  overflow: hidden;

  .v-card__text {
    display: flex;
    overflow: auto;
  }
}
</style>
